var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"funnel-container pl-0 pr-0",attrs:{"fluid":""}},[_c('GChart',{attrs:{"type":"AreaChart","data":_vm.chartData,"options":_vm.chartOptions}}),_c('img',{staticClass:"chart-icon",attrs:{"src":require("../../assets/DownIcon.png"),"alt":"Icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }